import { useTranslation } from '@/lib/i18n';
import { StatusPill } from '@/components/ui';
import { resolvePayoutStatus } from '@/lib/domain';

export interface PayoutStatusPillProps {
  status: string | null | undefined;
  payoutTxId?: string;
}

export const PayoutStatusPill = ({ status, payoutTxId }: PayoutStatusPillProps) => {
  const { t } = useTranslation('settlement');
  const meta = resolvePayoutStatus(status, payoutTxId ? { payoutTxId } : undefined);
  return (
    <StatusPill
      variant={meta.badge}
      displayStatus={status}
      label={t(meta.i18nKey, status ?? '')}
      testId="payout-status-pill"
    />
  );
};
